import React, { useEffect, useState } from 'react';
// import {useOnClickToolTipStyles} from "./useOnClickToolTipStyles";
import { Tooltip } from '@mui/material';

type Props = {
  children: JSX.Element;
  tooltipContent: string | JSX.Element;
  autoClosed?: boolean;
};

export const AutoCloseToolTip = ({ children, tooltipContent, autoClosed = true }: Props) => {
  // const classes = useOnClickToolTipStyles();
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (autoClosed) {
      let intervalId: NodeJS.Timeout | null = null;

      if (opened) {
        intervalId = setInterval(() => {
          setOpened(false);
        }, 2000);
      }

      return () => {
        if (intervalId) clearInterval(intervalId);
      };
    }
  }, [autoClosed, opened]);

  return (
    <>
      {tooltipContent ? (
        <div
          style={{ marginLeft: 'auto' }}
          onMouseEnter={() => setOpened(true)}
          onMouseLeave={() => !autoClosed && setOpened(false)}
          onClick={() => setOpened((prevState) => !prevState)}
        >
          <Tooltip open={opened} title={tooltipContent}>
            {children}
          </Tooltip>
        </div>
      ) : (
        children
      )}
    </>
  );
};
